export default __webpack_public_path__ + "static/media/Pastry-1.e58c70e2.jpg";